import { getConfigKey } from '../../api/public'
import { Message } from 'element-ui'
import { cookiesList, setCookie, getCookie } from '../../utils/cookies'
const app = {
    state: {
        globalServiceCharge: 0,
        merchantId: '' // 运营供应商
    },
    mutations: {
        setGlobalServiceCharge: (state, data) => {
            state.globalServiceCharge = +data
        },
        setMerchantId: (state, data) => {
            state.merchantId = data
        }
    },
    actions: {
        setMerchantId({commit, state}, data) {
            return new Promise((resolve, reject) => {
                let mid = data.mid
                if (data.page == 'list') {
                    if (!mid || isNaN(mid)) {
                        commit('setMerchantId', '')
                        setCookie(cookiesList.merchant_id, '')
                    } else if (mid && !isNaN(mid) && state.merchantId != mid) {
                        commit('setMerchantId', mid)
                        setCookie(cookiesList.merchant_id, mid)
                    } 
                } else if (data.page == 'other') {
                    if (mid && !isNaN(mid) && state.merchantId != mid) {
                        commit('setMerchantId', mid)
                        setCookie(cookiesList.merchant_id, mid)
                    } else if (state.merchantId) { 
                        // ...
                    } else if (!mid || isNaN(mid)) {
                        mid = getCookie(cookiesList.merchant_id)
                        mid && commit('setMerchantId', mid)
                    }
                }
                setTimeout(() => {
                    resolve()
                }, 500)
            })
        },
        setGlobalServiceCharge({commit}) {
            getConfigKey({
                configName: 'global_service_charge'
            }).then(res => {
                if (res.errorCode == 200) {
                    commit('setGlobalServiceCharge', res.data.config_value);
                } else {
                    Message({
                        type: 'error',
                        message: res.errorMsg || '获取系统配置出错'
                    })
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },

}

export default app